export default __webpack_public_path__ + "static/media/job-switching-list_Dark.5f362233.svg";